import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";


import { ProcessoConcluirDTO } from "../../../types/processo/ProcessoSetoresDTO";

import { useConcluirProcessoMutation } from "./processoConcluirApiSlice";



export const ProcessoConcluirForm = () => {


    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const navigate = useNavigate();
    const [create, status] = useConcluirProcessoMutation();


    // Hook para seleção do processo
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);

    const [observacao, setObservacao] = useState("");



    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();



        if (!observacao || observacao.length === 0) {
            enqueueSnackbar("Preencha a obsevação!", { variant: "error" });
            return;
        }
        const parms: ProcessoConcluirDTO = {
            id: "",
            processoId: processoSelecionado ? processoSelecionado.id : "",
            observacaoConcluido: observacao,
        }
        await create(parms);
    }

    useEffect(() => {

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);



    return (

        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Conclusão do processo: {processoSelecionado?.numeroProcesso}

                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    required
                                    label="Observação:"
                                    name="observacao"
                                    onChange={(e) => setObservacao(e.target.value)}
                                    size="small"
                                    inputProps={{ maxLength: 255 }}
                                    value={observacao}
                                    multiline  // Adicionando a propriedade 'multiline'
                                    rows={4}   // Definindo a altura inicial para 4 linhas
                                />
                                <FormHelperText>
                                    {observacao?.length}/255 caracteres
                                </FormHelperText>
                            </FormControl>
                        </Grid>







                        <Grid item xs={12}>
                            <Box display="flex" gap={2}>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                >
                                    Gravar
                                </Button>

                                <Button
                                    variant="contained"
                                    onClick={() => navigate(-1)}
                                >
                                    Voltar
                                </Button>
                            </Box>
                        </Grid>


                    </form>



                </Box>




            </Paper >










        </>







    );










};
